import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatAhv'
})
export class FormatAhvPipe implements PipeTransform {

  transform(ahvNr: string): string {
    if (!ahvNr) {
      return '';
    }
    if (ahvNr.length === 11) {
      return this.oldFormat(ahvNr);
    }
    if (ahvNr.length === 13) {
      return this.newFormat(ahvNr);
    }
    return '';
  }

  newFormat(ahvNr: string): string {
    const prefix = ahvNr.substr(0, 3);
    const part1 = ahvNr.substr(3, 4);
    const part2 = ahvNr.substr(7, 4);
    const part3 = ahvNr.substr(11, 2);
    return prefix + '.' + part1 + '.' + part2 + '.' + part3;
  }

  oldFormat(ahvNr: string): string {
    const prefix = ahvNr.substr(0, 3);
    const part1 = ahvNr.substr(3, 2);
    const part2 = ahvNr.substr(5, 3);
    const part3 = ahvNr.substr(8, 3);
    return prefix + '.' + part1 + '.' + part2 + '.' + part3;
  }

}
